import { ThemeProvider, createTheme, styled } from '@mui/material/styles';
export const vvpTheme = createTheme({
    components: {
        MuiListItemIcon: {
            styleOverrides: {
            root: {
                minWidth: 'unset',
                //paddingRight: '5px',
                color: 'inherit',
            },
            },
        },
        // Name of the component
        MuiButton: {
            styleOverrides: {
                // Name of the slot
                root: {
                    // Some CSS
                    fontSize: '14px',
                    fontWeight: '600',
                    borderRadius: '80px',
                    textTransform: 'capitalize',
                    height: '32px',
                    padding: '3px 8px',
                    '&:hover': {
                        backgroundColor: '#295166',
                        color: '#fff',
                    },
                    '&:active': {
                        backgroundColor: '#295166',
                        color: '#fff',
                    },
                    '&:focus': {
                        border: '3px solid #C6D7E2',
                        outline: 'none',
                    },
                    '&.Mui-disabled': {
                        backgroundColor: '#B4B5B6',
                        color: 'lightgray',
                    },
                },
                containedSecondary: {
                    backgroundColor: '#FFFFFF',
                    color: '#1A1919',
                    border: '1px solid #E0E3E5',
                    '&:hover': {
                        backgroundColor: '#fff',
                        border: '1px solid #B4B5B6',
                        color: '#1A1919',
                    },
                    '&:active': {
                        backgroundColor: '#fff',
                        color: '#1A1919',
                    },
                    '&:focus': {
                        color: '#1A1919',
                        border: '2px solid #005786',
                        outline: 'none',
                    },
                    '&.Mui-disabled': {
                        backgroundColor: '#fff',
                        color: '#B4B5B6f',
                        border: '1px solid #E0E3E5',
                    },
                },
            },
        },
        MuiDataGrid: {
            styleOverrides: {
                row: {
                    '&.parent-row': {
                        backgroundColor: '#F5F5F5 !important',
                        fontWeight: '400',
                    },
                    '&.child-row': {
                        backgroundColor: '#ffffff !important',
                    },
                    '&.child-row .MuiDataGrid-cell .MuiDataGrid-treeDataGroupingCell span': {
                        display: 'none',
                    }
                }
            }
        },
        MuiInputBase: {
            MuiOutlinedInput: {
                styleOverrides: {
                    root: {
                        borderRadius: '8px'
                    }
                }
            }
        },
        MuiPickersOutlinedInput:{
            styleOverrides: {
                root: {
                    borderRadius: '24px',
                }
            }
        }
    },
    palette: {
        primary: {
            main: '#005786',
        },
        secondary: {
            main: '#fff',
        },
        DataGrid: {
            headerBg: '#F5F5F5',
            borderColor: '#E0E3E5',
        },
        terciary: {
            main: '#C6D7E2',
            borderColor: '#C6D7E2',
            color: '#005786'
        }
    },
    typography: {
        fontFamily: 'Inter, sans-serif',
        
    },
})